import styles from './RelatedArticles.module.scss';
import NewDetailRelatedList from './List/NewDetailRelatedList';

export default function RelatedArticles({ fields }) {
  const relatedTitle = fields?.RelatedTitle?.value || 'Related articles';

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title} data-aos="fade-up">
        {relatedTitle}
      </h3>
      <NewDetailRelatedList fields={fields.related} />
    </div>
  );
}
